<template>
  <div class="input-group">
    <FormLabel
      :prepend="prepend"
      :required="required">
      <input
        :disabled="disabled"
        :value="value"
        :class="{'text-left': align == 'left', 'text-right': align == 'right', 'text-center': align == 'center'}"
        :type="type"
        :placeholder="placeholder"
        class="form-control"
        @input="$emit('input', $event.target.value)">
    </FormLabel>
  </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel';

export default {
  name: 'FormInput',
  components: { FormLabel },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    prepend: {
      type: String,
      default: null,
    },
    align: {
      type: String,
      default: 'left',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.input-group {
  align-items: center;
}
.form-control {
  display: flex;
}
i {
  font-size: 10px;
}
</style>
